import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { cookieStorage, createStorage, http } from '@wagmi/core'
import { mainnet, polygon, base } from '@reown/appkit/networks' // Remove solana import, keep base

// Project ID from WalletConnect Cloud
// Use the more standard environment variable name
export const projectId = process.env.NEXT_PUBLIC_PROJECT_ID || ''

// Define all supported networks using imported constants
// Remove solana from the networks array
export const networks = [mainnet, polygon, base] as any;

// Custom RPC URLs might still be useful for overriding defaults
export const customRpcUrls = {
  'eip155:1': [{ url: 'https://ethereum.publicnode.com' }], // Ethereum mainnet
  'eip155:137': [{ url: 'https://polygon-rpc.com' }], // Polygon mainnet
  // Remove Solana RPC URL entry if present
}

// Create storage
const storage = createStorage({
  storage: cookieStorage
})

// Create Wagmi adapter - pass the common networks array
export const wagmiAdapter = new WagmiAdapter({
  projectId,
  storage,
  ssr: true,
  networks, // Pass the combined network array
  // Explicitly define transports for networks where we want to override the default RPC
  transports: {
    [polygon.id]: http('https://polygon.llamarpc.com'), // Use a reliable public RPC for Polygon
    [base.id]: http('https://mainnet.base.org'), // Use the official Base RPC endpoint
    // [mainnet.id]: http(), // Can add others if needed, http() uses default
  }
})

// Re-export chain IDs as numbers for use in components
export const ETHEREUM_CHAIN_ID = mainnet.id;
export const POLYGON_CHAIN_ID = polygon.id;
export const BASE_CHAIN_ID = base.id;
// Remove Solana chain ID constant if present